/**
 * Parses an HTML string containing an ordered list (ol) with list items (li),
 * where each li contains a <strong> tag followed by text.
 * Extracts the text from the <strong> tag (as title) and the subsequent text (as value).
 *
 * @param {string} htmlString The HTML string to parse (e.g., "<ol><li><strong>Title</strong> Value</li>...</ol>").
 * @returns {Array<{title: string, value: string}>} An array of objects, each with 'title' and 'value'. Returns an empty array if input is invalid or no matching items are found.
 */
export const parseListItems = (htmlString) => {
  const results = []

  if (typeof htmlString !== 'string' || !htmlString) {
    console.warn('Invalid input: htmlString must be a non-empty string.')
    return results
  }

  try {
    const template = document.createElement('template')
    template.innerHTML = htmlString.trim()
    const listItems = template.content.querySelectorAll('li')

    listItems.forEach((li) => {
      const strongElement = li.querySelector('strong')

      if (strongElement) {
        const title = strongElement.textContent.trim()
        let value = ''
        const nextNode = strongElement.nextSibling

        if (nextNode && nextNode.nodeType === Node.TEXT_NODE) {
          value = nextNode.textContent.trim()
        }
        results.push({ title: title, value: value })
      } else {
        console.warn('Found <li> without a <strong> tag:', li.innerHTML)
      }
    })
  } catch (error) {
    console.error('Error parsing HTML string:', error)
    return []
  }

  return results
}

/**
 * Parses an HTML string containing an list (ol, ul) with list items (li),
 *
 * @param {string} htmlString The HTML string to parse (e.g., "<ol><li><strong>TEXT</strong> TEXT</li>...</ol>").
 * @returns {Array<string>} An array of string, returns an empty array if input is invalid or no matching items are found.
 */

export const parseListItemsText = (htmlString) => {
  const results = []

  if (typeof htmlString !== 'string' || !htmlString) {
    console.warn('Invalid input: htmlString must be a non-empty string.')
    return results
  }

  try {
    const template = document.createElement('template')
    template.innerHTML = htmlString.trim()
    const listItems = template.content.querySelectorAll('li')
    console.log(listItems)

    listItems.forEach((li) => {
      results.push(li.innerHTML.trim())
    })
  } catch (error) {
    console.error('Error parsing HTML string:', error)
    return []
  }

  return results
}
